import { render, staticRenderFns } from "./TextPhases.vue?vue&type=template&id=6b612e28&scoped=true"
import script from "./TextPhases.vue?vue&type=script&lang=js"
export * from "./TextPhases.vue?vue&type=script&lang=js"
import style0 from "./TextPhases.vue?vue&type=style&index=0&id=6b612e28&prod&lang=scss"
import style1 from "./TextPhases.vue?vue&type=style&index=1&id=6b612e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b612e28",
  null
  
)

export default component.exports